import { removeItem } from "@/utils/va-order-test/testAndPanelSelection";
import _ from "lodash";

export function getOrderObjForBackend(orderForFrontend, orderType = null, modifiedOrderSampleId = null) {
  let { 
    phone, 
    orderItems, 
    priceDetails, 
    deliveryMethod, 
    paymentId, 
    patientId, 
    isUseCredit,
    creditType,
    usedCredit, 
    chargeMethod, 
    email,
    sendNotification,
    sendDate,
    noteToPatient,
    dbs,
    coupon,
    draftId,
    shippingFeeDetails,
    isUseTax,
    taxId,
    isUseConciergeFee,
    isUseConsultationFee,
    providerHasRevenue,
    currency,
    pediatricConsentInfo
  } = orderForFrontend;
  let { 
    orderTestsPrice, 
    labProcessingFee,
    shippingFee, 
    priceBeforeDiscount, 
    priceAfterDiscount,
    priceAfterClientPromo,
    conciergeFee,
    consultationFee,
    consultationFeeName,
    merchTotalPrice,
    taxFee,
  } = priceDetails;
  let discount_amount = (priceBeforeDiscount - priceAfterClientPromo).toFixed(2);  
  let delivery_method = {
    blood: deliveryMethod.blood,
    non_blood: deliveryMethod.nonBlood,
    dry_ice: deliveryMethod.dryIce
  };
  // if an order is a free order(use a 100% off coupon)
  // then total will be price before discount
  // in this case, same as actual_price
  
  // In Frontend edit/addon order, need to show merch even when quantity == 0;
  // filter those quantity 0 merch here
  orderItems = orderItems.filter((item) => {
    return !item.item_type || item.item_type != "merchandise"
      || Boolean(item.quantity && item.quantity > 0);
  });
  
  let isFreeOrder = coupon && priceAfterDiscount === 0 ? true : false;
  let total = (isFreeOrder ? priceBeforeDiscount : priceAfterClientPromo).toFixed(2);
  let orderForApi = {
    payment_id: paymentId,
    patientId,
    isFreeOrder,
    total,
    chargeMethod,
    originalPrice: (orderTestsPrice + merchTotalPrice).toFixed(2),
    discount_amount,
    actual_price: priceBeforeDiscount.toFixed(2),
    lab_processing_fee: labProcessingFee.toFixed(2),
    international_shipping_fee: shippingFee.toFixed(2),
    international_shipping_fee_details: {
      import: shippingFeeDetails.importFee.toFixed(2),
      export: shippingFeeDetails.exportFee.toFixed(2)
    },
    email,
    send_email: sendNotification.email,
    cell_phone: phone,
    send_text: sendNotification.text,
    orderItems,
    delivery_method,
    bloodKitDeliveryMethod: deliveryMethod.blood,
    nonBloodKitDeliveryMethod: deliveryMethod.nonBlood,
    dryIceKitDeliveryMethod: deliveryMethod.dryIce,
    send_date: sendDate,
    note_to_patient: noteToPatient,
    dbs,
    coupon,
    draft_id: draftId ? parseInt(draftId) : null,
    use_credit: isUseCredit,
    credit_type: creditType,
    credit_apply_amount: usedCredit ? usedCredit.toFixed(2) : null,
    isUseTax,
    taxId,
    taxFee: taxFee.toFixed(2),
    is_valid_concierge: isUseConciergeFee,
    concierge_fee: isUseConciergeFee ? conciergeFee.toFixed(2) : "0",
    is_use_consultation_fee: isUseConsultationFee,
    consultation_fee: isUseConsultationFee ? consultationFee.toFixed(2) : "0",
    consultation_fee_customized_name: isUseConsultationFee ? consultationFeeName : "",
    currency
  };
  if (pediatricConsentInfo) {
    orderForApi.pediatric_consent_info = pediatricConsentInfo;
  }
  if (orderType) {
    orderForApi.order_update_method = orderType;
    orderForApi.sampleId = modifiedOrderSampleId;
  }
  if (providerHasRevenue) {
    orderForApi.providerHasRevenue = providerHasRevenue;
  } else {
    orderForApi.providerHasRevenue = false;
  }
  return orderForApi;
}

export function distributeSampleIdsToOrder(samplePriceMap, sampleIdJulienBarcodeMap, orderList) {
  let sampleIds = [...Object.keys(samplePriceMap)];
  // add sampleId & julien barcode to each order
  orderList.forEach(order => {
    // both samplePriceMap[id] and order.total should be string & fixed to 2 decimal places
    let price = order.isFreeOrder ? 0 : Number(order.total);
    let orderSampleId = sampleIds.find(id => Number(samplePriceMap[id]) === price);
    if (orderSampleId) {
      order.sampleId = Number(orderSampleId);
      order.julienBarcode = sampleIdJulienBarcodeMap[orderSampleId];
      // remove selected id from sampleIds
      removeItem(orderSampleId, sampleIds);
    }
  })
}

export function getFamilyMemberOrderForApi(familyMemberOrder, mainOrder) {
  let { payment_id, chargeMethod, email, send_email, cell_phone, send_text, delivery_method, bloodKitDeliveryMethod, nonBloodKitDeliveryMethod, dryIceKitDeliveryMethod, send_date, note_to_patient, dbs, currency } = mainOrder;
  let { patient, tests,price } = familyMemberOrder;
  let originalPrice = tests.reduce((acc, test) => acc + test.originalPrice, 0);
  let orderItems = [];
  tests.forEach(test => {
    orderItems.push({
      item_id: test.id,
      item_type: "packagePriceId",
      original_price: test.originalPrice.toString(),
      total: test.price.toString(),
      package_id: null,
      shortcut_id: null,
      markup: null,
      markup_version: null,
      customized_name: null,
    });
  })
  let order = {
    payment_id,
    patientId: patient.id,
    isFreeOrder: false,
    total: price.toFixed(2),
    chargeMethod,
    originalPrice: originalPrice.toFixed(2),
    discount_amount: "0",
    actual_price: price.toFixed(2),
    lab_processing_fee: "0",
    international_shipping_fee: "0",
    international_shipping_fee_details: {
      import: "0",
      export: "0"
    },
    email,
    send_email,
    cell_phone,
    send_text,
    orderItems,
    delivery_method,
    bloodKitDeliveryMethod,
    nonBloodKitDeliveryMethod,
    dryIceKitDeliveryMethod,
    send_date,
    note_to_patient,
    dbs,
    coupon: "",
    draft_id: null,
    use_credit: false,
    credit_type: null,
    credit_apply_amount: null,
    isUseTax: false,
    taxId: "",
    taxFee: "0",
    is_valid_concierge: false,
    concierge_fee: "0",
    is_use_consultation_fee: false,
    consultation_fee: "0",
    consultation_fee_customized_name: "",
    currency,
    isFamilyMainOrder: false,
    providerHasRevenue: false,
  }
  return order;
}

export function distributeCreditToOrders(orderList, isUseCredit, creditAmount, creditType) {
  let remainingCredit = creditAmount;
  if (!isUseCredit || remainingCredit <= 0) {
    return;
  }
  orderList.forEach(order => {
    let usedCredit = Math.min(remainingCredit, order.total);
    if (usedCredit > 0) {
      // update order credit related fields
      order.use_credit = true;
      order.credit_type = creditType;
      order.credit_apply_amount = usedCredit.toFixed(2);
      // update remaining credit
      remainingCredit -= usedCredit;
    }
  })
}